<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a User</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form ref="form" class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">Name*</label>
            <v-text-field 
              required
              placeholder="Enter User Name"
              v-model="user.display_name">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Email*</label>
            <v-text-field 
              required
              placeholder="Enter User Name"
              v-model="user.email">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Primary Phone*</label>
            <v-text-field 
              required
              placeholder="Enter User Phone"
              v-model="user.primary_phone">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Secondary Phone</label>
            <v-text-field 
              placeholder="Enter User Phone"
              v-model="user.secondary_phone">
            </v-text-field>
          </div>

          <div class="field"
            v-if="roles && roles.length > 0">
            <label class="label">Role</label>
            <v-select
              :options="roles"
              item-text="name"
              item-value="value"
              v-model="user.role"
            />      
          </div>

          <div class="field"
            v-if="policies && policies.length > 0">
            <label class="label">Policy</label>
            <v-select
              :options="policies"
              item-text="name"
              item-value="id"
              v-model="user.policy_id"
            />    
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNewUser()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'

export default {
  props: {
    value: {
      type: Boolean
    },
    roles: {
      type: Array
    }
  },
  components: { VTextField, VForm, VSelect },
  data() {
    return {
      user: {
        email: '',
        is_active: true,
        display_name: '',
        primary_phone: '',
        secondary_phone: '',
        sign_in_method: '',
        role: '',
        policy_id: null
      },
      valid: false
    }
  },
  methods: {
    ...mapActions("users", ["addUser"]),
    ...mapActions("permissions", ["getPolicies"]),
    initialize() {
      this.getPolicies();
    },
    addNewUser() {
      this.addUser(this.user).then(resp => {
        this.$emit('finishCreate', resp.data);
        this.$emit('success', resp.data);
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  },
  computed: {
    ...mapState("permissions", ["policies"])
  },
  created() {
    this.initialize();
  }
}
</script>
